<donut-droppable id="trash-bin" :style="trashStyle" @drop="drop"><i class="mi">delete</i></donut-droppable>